export const Skill = ({ skill }) => (
  <div key={skill.skillId} className="margin-min-vertical">
    <span className="text-muted margin-right">-</span>
    <span>{skill.name}</span>
    {skill.description && <div className="description small text-muted">{skill.description}</div>}
  </div>
);
